<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="1200px"
    >
      <v-card max-height="630">
        <v-toolbar
          color="primary"
          dark
        >
          <v-toolbar-title> Detalhes Logs </v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            dark
            @click="CLOSE_DIALOG"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="">
          <div
            v-if="!detalhesLog"
          >
            <v-skeleton-loader
              type="table"
              max-height="464px"
            />
          </div>
          <div v-else>
            <v-container fluid>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="search"
                    label="Buscar Tarefa"
                    outlined
                    dense
                    rounded
                    hide-details
                    @change="filterDetalhesLog"
                  />
                </v-col>
              </v-row>
            </v-container>
            <v-simple-table
              fixed-header
              height="400px"
            >
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Tarefa</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in datalhesLogFiltered"
                  :key="item.id"
                >
                  <td>{{ moment(item.logged_at).format('DD/MM/YYYY HH:mm:ss') }}</td>
                  <td>{{ item.type }}</td>
                  <td>
                    <v-chip
                      :color="colorStatus(item.status)"
                      small
                      class="mb-2 pl-4 pr-4 my-1"
                    >
                      {{ item.status }}
                    </v-chip>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error"
            rounded
            class="text-none"
            @click="CLOSE_DIALOG"
          >
            <v-icon
              dark
              left
            >
              mdi-minus-circle
            </v-icon>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import { LOAD_DETALHES, CLOSE_DIALOG } from '@/store/modules/logs'
  import { mapState, mapActions } from 'vuex'
  import { StatusLog } from '../../utils/constants'

  export default {
    props: {

    },

    data () {
      return {
        search: '',
      }
    },

    computed: {
      ...mapState('logs', ['dialog', 'detalhesLog']),
      formattedJSON () {
        return JSON.stringify(this.item.data, null, 2)
      },
      datalhesLogFiltered () {
        if (!this.search) {
          return this.detalhesLog
        }
        return this.detalhesLog.filter(item => {
          return item.type.toLowerCase().includes(this.search.toLowerCase())
        })
      },
    },

    methods: {
      ...mapActions('logs', [LOAD_DETALHES, CLOSE_DIALOG]),
      colorStatus (status) {
        if (status === StatusLog.FINALIZADO) {
          return 'success'
        } else if (status === StatusLog.CANCELADO || status === StatusLog.ERROR) {
          return 'error'
        } else if (status === StatusLog.EM_ANDAMENTO) {
          return 'warning'
        }
      },
    },
  }
</script>
